/** Invoicing permission strings (reuse payroll admin capabilities until a dedicated role exists). */
export const InvoicingPermissions = {
  workspaceAccess: [
    'manage_payroll',
    'payroll_admin_dashboard_read',
    'payroll_manage_pay_period',
  ] as const,
} as const
